// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a3wi","top":"styles_top__hxh0d","left":"styles_left__3w9k4","description":"styles_description__1r97m"};